import { HttpSuccessDto } from '@common/dto/http';
import { IndividualListDto } from '@common/dto/individual/list-dto';
import { InviteListDto } from '@common/dto/invite/list-dto';
import { QuestionnaireGetDto } from '@common/dto/questionnaire/get-dto';
import { QuestionnaireListDto } from '@common/dto/questionnaire/list-dto';
import client from '@common/utils/rest';

export const getQuestionnaires = async (params: { includeFamilyQuestionnaires: boolean, includeFhq4Questionnaires: boolean, includeHiddenQuestionnaires: boolean }): Promise<Array<QuestionnaireListDto>> => {
  return client({
    path: 'api/questionnaire/getQuestionnaires',
    params,
    method: 'GET'
  }).then((response: HttpSuccessDto<Array<QuestionnaireListDto>>) => {
    return response.entity;
  });
};

export const launchNewIndividualQuestionnaire = (globalId: IndividualListDto['id'], questionnaireId: QuestionnaireListDto['questionnaireId'] | undefined, isFHQ4: boolean | undefined): Promise<string> => {
  return client({
    params: {
      globalId,
      questionnaireId,
      isFHQ4,
    },
    path: 'api/questionnaire/launchNewIndividualQuestionnaire',
    method: 'POST',
  }).then((response: HttpSuccessDto<string>) => {
    return response.entity;
  });
};

export const getQuestionnaireForInvite = async (inviteId: InviteListDto['id'], fhq4: boolean): Promise<QuestionnaireGetDto> => {
  return client({
    path: 'api/questionnaire/loadQuestionnaireForInvite',
    params: {
      inviteId,
      fhq4,
    },
    method: 'GET'
  }).then((response: { entity: { data: QuestionnaireGetDto } }) => {
      return response.entity.data;
    });
};

export const openInviteQuestionnaire = (questionnaire: { inviteId: number; fhq4: boolean }, baseUrl: string): Promise<{ url: string }> => {
  return client({
    params: {
      inviteId: questionnaire.inviteId,
      baseUrl,
      fhq4: questionnaire.fhq4,
    },
    path: 'api/individuals/launchQuestionnaire',
    method: 'GET',
  }).then((response: HttpSuccessDto<{ url: string }>) => {
    return response.entity;
  });
};